var StudentDisplay = require("components/users/students/StudentDisplay");

var ItemHeader = function(props) {
	if (props.date) {
		var dateDisplay = (
			<div className="date">
				{ $wr.formatDateTime(props.date, "show-past-years") }
			</div>
		)
	}
	if (props.pageBreak) {
		var pageBreak = (
			<div className="pageBreak" />
		);
	}
	return (
		<div className="itemHeader">
			{ pageBreak }
			<div className="itemHeaderInner">
				<div className="innerHeader clearfix">
					<div className="student">
						<StudentDisplay studentID={ props.studentID } showAvatar avatarMaxWidth={ 40 } />
					</div>
					{ dateDisplay }
				</div>
			</div>
		</div>
	);

};

ItemHeader.propTypes = StrictPropTypes({
	date: PropTypes.string,
	studentID: PropTypes.number,
	pageBreak: PropTypes.bool
});

module.exports = ItemHeader;



// WEBPACK FOOTER //
// ./modules/components/data/subjects/shared/ItemHeader.js